import { AnnotationType } from 'types/building'

/**
 * Checks whether an annotation object or type represents a Comment annotation
 */
export function isCommentAnnotation(
  annotation?: any,
  annotationType?: any
): boolean {
  if (!annotation && annotationType === undefined) return false

  const type = annotationType ?? annotation?.type
  const numType = Number(type)
  const strType = String(type || '').toUpperCase()

  return (
    numType === Number(AnnotationType.COMMENT) ||
    numType === 42 ||
    strType === 'COMMENT' ||
    strType === '42' ||
    Boolean(annotation?.comment_object) ||
    Boolean(annotation?.commentObject) ||
    Boolean(annotation?.comment)
  )
}

export default isCommentAnnotation
